import React from "react";
import { Box, Stack, Typography } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";
import MediaCardPrimary from "./MediaCardPrimary";

const PrimaryCard = () => {
  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Primary Card
        </Typography>
        <Typography variant={"body2"} color={"text.primary"}>
          This is Primary Card.
        </Typography>
      </Box>
      <Box sx={{ width: "80%", alignSelf: "center" }}>
        <PreviewAndEditor height={"300px"} language="js" value={""}>
          <MediaCardPrimary />
        </PreviewAndEditor>
      </Box>
    </Stack>
  );
};

export default PrimaryCard;
